import { providers } from '@takeshape/service-providers';
import { avatars, logos } from '../assets/index.js';
import { serviceProviderUiDefaults } from '../util/index.js';

export default providers.olyslager.extend({
  ...serviceProviderUiDefaults,
  titleToNamespace: true,
  hasIntrospectableSchema: Boolean(providers.olyslager.introspectionType),
  defaultAuthenticationType: 'bearer',
  avatarPath: avatars.olyslager,
  logoPath: logos.olyslager
});
